import { render, staticRenderFns } from "./ParentList.vue?vue&type=template&id=6fb7fd81&scoped=true"
import script from "./ParentList.vue?vue&type=script&lang=js"
export * from "./ParentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb7fd81",
  null
  
)

export default component.exports